// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__TBRAW","col":"styles_col__3qCrk"};